import { render } from "./PoliticalReview.vue?vue&type=template&id=64fe31fe&scoped=true"
import script from "./PoliticalReview.vue?vue&type=script&lang=js"
export * from "./PoliticalReview.vue?vue&type=script&lang=js"

import "./PoliticalReview.vue?vue&type=style&index=0&id=64fe31fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fe31fe"]])

export default __exports__